import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";

import Navbar from "./Navbar/Navbar";
import IconsWraapper from "./IconsWraapper";
import hangingPoster1 from "../assets/Images/hanging-poster-1.png";
import hangingPoster2 from "../assets/Images/hanging-poster-2.png";

import arrowLeft from "../assets/Images/arrowL.png";
import arrowRight from "../assets/Images/arrowR.png";

const Header = () => {
  const [imageWidth, setImageWidth] = useState(0);

  const [innerWidth, setInnerWidth] = useState(0);

  const handleResize = () => {
    setInnerWidth(window.innerWidth);
  };

  useEffect(() => {
    setImageWidth(document.getElementById("parentRef").offsetWidth);
  }, [handleResize]);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize, { passive: true });
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  const ArrowBtns = () => {
    return (
      <div className=" bg-[#fff] w-2/4 -bottom-1 -right-1 absolute gap-2 flex flex-row py-4  md:py-5">
        <div className="w-1/2 flex justify-center items-center pl-2 ">
          <img
            src={arrowLeft}
            alt="prec"
            className="cursor-pointer  opacity-90 hover:opacity-100"
            // onClick={() => prev()}
          />
        </div>
        <div className="w-1/2 flex justify-center items-center pr-2">
          <img
            src={arrowRight}
            alt="next"
            className="cursor-pointer opacity-90 hover:opacity-100"
            // onClick={() => next()}
          />
        </div>
      </div>
    );
  };

  return (
    <section className="w-full  overflow-x-hidden relative px-5 ">
      <Navbar active="Home" />

      <div className="flex md:flex-row flex-col justify-start  gap-5    ">
        <div className=" justify-start w-full md:w-2/4">
          <p
            className="text-[40px] lg:text-[72px] md:text-[50px]  text-left font-Play
            leading-[2.7rem] md:leading-tight	
            "
          >
            Create your Logo Online in a Few Clicks for free.{" "}
          </p>

          <div
            className="flex w-full mt-[22px] md:mt-[50px] 
          mb-[20px] md:mb-[90px] gap-2 flex-col md:flex-row items-start md:gap-4 flex-wrap "
          >
            <button
              className="
              text-[18px] font-semibold
              w-full h-[70px]
              md:w-[330px] 
              bg-primary text-[#fff]
                
            "
            >
              <NavLink to="/gallery" className="w-full h-full">
                CREATE A FREE LOGO DESIGN
              </NavLink>
            </button>
          </div>

          <div className="hidden md:block w-1/2 ">
            <IconsWraapper />
          </div>
        </div>

        <div className=" hidden md:flex w-2/4   max-w-[572px]   ">
          <div id="parentRef" className="w-1/2">
            <img
              src={hangingPoster2}
              alt="header png"
              className="absolute max-w-[286px] top-0 "
              style={{
                width: imageWidth ? imageWidth : 0,
                height: imageWidth ? imageWidth : 0,
              }}
            />
          </div>
          <div className="w-1/2  ">
            <div className="relative" style={{ width: imageWidth ? imageWidth : 0 }}>
              <img
                src={hangingPoster1}
                className="max-w-[286px] w-full"
                alt="header png"
              />
              <ArrowBtns />
            </div>
          </div>

          {/* <div className=" md:absolute top-0 flex">
           
             <div className="hidden lg:block w-1/2 just">
              <img src={hangingPoster2} className=" w-60 " alt="header png" />
            </div>
            <div className="md:w-2/4 ml-auto relative ">
             <img
                src={hangingPoster1}
                className="w-60 mt-20 ml-auto"
                alt="header png"
              />

              <ArrowBtns />
              
            </div> 
          </div> */}
        </div>
      </div>

      <div className="flex flex-row md:hidden ">
        <div className="w-2/4 pr-2 ">
          <div className="relative">
            <img src={hangingPoster1} className="w-full" alt="header png" />
            <ArrowBtns />
          </div>
        </div>
        <div className="w-2/4  flex flex-row-reverse">
          <IconsWraapper />
        </div>
      </div>

      <div className="h-[100px] "></div>
    </section>
  );
};

export default Header;
